import * as React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import {
  Divider,
  Grid,
  Paper,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

import styles from './styles';
import Aside from '../Aside';
import Usage from '../Usage';
import Variations from '../Variations';
import MiscellaneousSection from '../MiscellaneousSection';
import ExamplesSection from '../ExamplesSection';
import ProcessSection from '../ProcessSection';
import AdditionalSection from '../AdditionalSection';

interface IDetailsContentProps extends WithStyles<typeof styles> {
  title?: RichTextBlock[];
  header_content?: RichTextBlock[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aside_items?: Array<any>;
  page_color?: string;
  page_font_color?: string;
  group?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list_items?: Array<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additional_content?: Array<any>;
  page_title?: RichTextBlock[];
  parent_slug?: string;
}

const DetailsContent: React.FunctionComponent<IDetailsContentProps> = ({
  classes,
  title,
  header_content,
  aside_items,
  page_color,
  page_font_color,
  group,
  list_items,
  additional_content,
  page_title,
  parent_slug,
}) => {
  if (header_content) {
    return (
      <Paper>
        <Grid container className={classes.direction}>
          <Grid item xs={12} md={3} className={classes.asideContainer}>
            <Aside
              title={title}
              group={group}
              page_color={page_color}
              page_font_color={page_font_color}
              list_items={aside_items}
              page_title={page_title}
              parent_slug={parent_slug}
            ></Aside>
          </Grid>
          <Grid item xs={12} md={8} className={classes.container}>
            <MiscellaneousSection content_items={list_items}></MiscellaneousSection>
            <ProcessSection content_items={list_items}></ProcessSection>
            <ExamplesSection content_items={list_items}></ExamplesSection>
            <AdditionalSection content_items={list_items}></AdditionalSection>
          </Grid>
        </Grid>
      </Paper>
    );
  } else {
    React.useEffect(() => {
      if (location.hash.length != 0) {
        setTimeout(() => {
          location.href = `${location.hash}`;
        }, 0);
      }
    });
    return (
      <Paper>
        <Grid container className={classes.direction}>
          <Grid item xs={12} md={3} className={classes.asideContainer}>
            <Aside
              group={group}
              page_color={page_color}
              page_font_color={page_font_color}
              list_items={list_items}
              page_title={page_title}
              parent_slug={parent_slug}
            ></Aside>
          </Grid>
          <Grid item xs={12} md={8} className={classes.container}>
            <AdditionalSection content_items={additional_content}></AdditionalSection>
            {list_items.map((item, i) => {
              const group_type = item.node._meta.tags[0];
              const item_uid = item.node._meta.uid;
              const item_title = item.node.title;
              const item_description = item.node.description;
              const main_content_items = item.node.main_content;
              const primary_usage_items = item.node.primary_usage_list;
              const usage_notification_items = item.node.usage_notification;
              const variations_description = item.node.e_v_description
                ? item.node.e_v_description
                : null;
              const variations_examples = item.node.body;
              const variations_items = item.node.e_v_notification;
              if (group_type === group) {
                return (
                  <React.Fragment key={i}>
                    {/* TODO: figure out a better way to do this (prevents section links from hiding under nav bar) */}
                    <div style={{ paddingTop: '2rem' }} id={item_uid}></div>
                    <Typography
                      variant="h2"
                      className="lowercase"
                      align="left"
                      padding={{ top: 6 }}
                    >
                      {RichText.asText(item_title)}
                    </Typography>
                    <Divider className={classes.boldDivider} />
                    {usage_notification_items ? (
                      <Usage
                        item_uid={item_uid}
                        item_description={item_description}
                        main_content_items={main_content_items}
                        primary_usage_items={primary_usage_items}
                        usage_notification_items={usage_notification_items}
                      ></Usage>
                    ) : null}
                    {variations_examples && variations_examples.length !== 0 ? (
                      <Variations
                        description={variations_description}
                        variations_examples={variations_examples}
                        variations_items={variations_items}
                      ></Variations>
                    ) : null}
                  </React.Fragment>
                );
              }
            })}
          </Grid>
        </Grid>
      </Paper>
    );
  }
};

export default withStyles(styles)(DetailsContent);
